import {AxiosError, AxiosRequestConfig} from 'axios';
import {Service} from "@/services/superclasses/service";
import store from "@/store";
import {
    REFRESH_ACCESS_TOKEN
} from "@/store/action-types";

export class SecureService extends Service {

    private xRetrying = "X-Retrying";
    private xAuthorization = "X-Authorization";

    constructor(config?: AxiosRequestConfig) {
        super(config);

        // Don't, because then it does this all the time, for people not logged in.
        // // Queue a request for an access token as soon as possible, so we won't have to wait for one,
        // // once the first secure request is submitted.
        // store.dispatch(REFRESH_ACCESS_TOKEN);

        this.getAxiosInstance().interceptors.request.use(
            (config) => {
                if (store.state.accessToken) {
                    config.headers[this.xAuthorization] = `Access ${store.state.accessToken}`;
                    return config;
                } else {
                    return this.retry(config);
                }
            },
            err => err
        );
        this.getAxiosInstance().interceptors.response.use(
            response => response,
            (error: AxiosError) => {
                if (error.config && error.response) {
                    const retrying = error.config.headers ? error.config.headers[this.xRetrying] : false;
                    if (error.response.status === 401 && !retrying) {
                        return this.retry(error.config).then((config: AxiosRequestConfig) => {
                            return this.request(config);
                        });
                    }
                }
                return Promise.reject(error);
            },
        );
    }

    private retry = (config: AxiosRequestConfig): Promise<any> => {
        return store.dispatch(REFRESH_ACCESS_TOKEN, () => {
            config.headers[this.xRetrying] = true;
            config.headers[this.xAuthorization] = `Access ${store.state.accessToken}`;
            return config;
        });
    }
}